import { render, staticRenderFns } from "./actGame.vue?vue&type=template&id=1b878de6"
import script from "./actGame.vue?vue&type=script&lang=js"
export * from "./actGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports